export const NEW_PORTAL_REGIONS = [
  'Freiburg im Breisgau',
  'Erlebnisregion Europa-Park',
  'Wunsiedel',
  'Dettingen an der Erms',
  'Bad Waldsee',
  'Baden-Baden',
  'Stuttgart Mitte',
  'Besigheim',
  'Pfullingen',
  'Rotenburg an der Wümme',
  'Ratingen',
  'Flensburg',
  'Calw',
  'Abensberg',
  'Neuried',
  'Plettenberg',
  'Balingen',
  'Kenzingen',
  'Leinfelden-Echterdingen',
  'Schwabach',
  'Neubulach',
  'Haslach',
  'Flein',
  'Kirchheim unter Teck'
]
